<template>
  <div class="distributor-commission">
    <div class="relative">
      <SearchComponent :condition="condition" :routeName="$route.name" @updateData="_updateData" source="distributor"
        ref="search">
        <template #default="{ condition, pickerOptions, searchData, filterDownData }">
          <div class="input-box" v-if="$store.state.entryType === 'admin'">
            <span class="name">商家：</span>
            <div class="input">
              <el-select placeholder="请选择" clearable v-model="condition.merchant">
                <el-option :label="item.label" :value="item.value" v-for="item in filterDownData('merchantList')"
                  :key="item.value" />
              </el-select>
            </div>
          </div>
          <div class="input-box">
            <span class="name">订单号：</span>
            <div class="input">
              <el-input v-model="condition.orderNumber" placeholder="请输入" clearable />
            </div>
          </div>
          <div class="input-box">
            <span class="name">商品SKU编码：</span>
            <div class="input">
              <el-input v-model="condition.sku" placeholder="请输入" clearable />
            </div>
          </div>
          <div class="input-box">
            <span class="name">商品名称：</span>
            <div class="input">
              <el-input v-model="condition.goodsName" placeholder="请输入" clearable />
            </div>
          </div>
          <div class="input-box">
            <span class="name">订单来源：</span>
            <div class="input">
              <el-select placeholder="请选择" v-model="condition.orderSource" clearable>
                <el-option :label="item.label" :value="item.value" v-for="item in filterDownData('orderSource')"
                  :key="item.value" />
              </el-select>
            </div>
          </div>
          <div class="input-box">
            <span class="name">分销商账号：</span>
            <div class="input">
              <el-input placeholder="请输入" v-model="condition.distributorAccount" clearable />
            </div>
          </div>
          <div class="input-box datepick">
            <span class="name">对账单时间：</span>
            <div class="input ">
              <el-date-picker v-model="condition.time" type="daterange" unlink-panels range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"
                :picker-options="pickerOptions" clearable />
            </div>
          </div>
          <div class="input-box">
            <span class="name">支付方式：</span>
            <div class="input">
              <el-select placeholder="请选择" v-model="condition.paymentType" clearable>
                <el-option :label="item.label" :value="item.value" v-for="item in filterDownData('paymentList')"
                  :key="item.value" />
              </el-select>
            </div>
          </div>
          <el-button size="60" class="iconfont icon-sousuo" round @click="searchData" />
        </template>
      </SearchComponent>
      <TableComponent @updateData="_updateData" :pagination="pagination" :routeName="$route.name">
        <template #default="{ handleSelectionChange, jumpRoute }">
          <div class="table">
            <el-table v-min-height :data="tableData" :height="500" @selection-change="handleSelectionChange" border
              :header-cell-style="{
                background: 'transparent'
              }" header-cell-class-name="theader-th__table" cell-class-name="tbody-td__table"
              class="no-hover no-pad__bor">
              <el-table-column fixed type="selection" align="center" width="60" class-name="top-check" />
              <el-table-column label="商品标题" align="center" min-width="400" class-name="visible">
                <template slot-scope="scope">
                  <span class="top-bg" style="padding-left: 2rem">
                    订单号：{{ scope.row.orderNumber }}
                  </span>
                  <div class="order-details">
                    <div :class="
                      scope.row.goodsList.length > 1
                        ? 'box bor-bottom'
                        : 'box'
                    " v-for="(item, index) in scope.row.goodsList" :key="index">
                      <el-image :src="item.imgUrl" class="goods-img">
                        <div slot="error" class="image-slot">
                          <i class="iconfont icon-tupian" />
                        </div>
                      </el-image>
                      <div class="caption">
                        <p class="ellipses">
                          <el-tooltip effect="light" placement="bottom-start" :content="item.cnName">
                            <span class="goods-name"> {{ item.cnName }}</span>
                          </el-tooltip>
                        </p>
                        <p class="ellipses">
                          <el-tooltip effect="light" placement="bottom-start" :content="item.enName">
                            <span class="goods-name"> {{ item.enName }}</span>
                          </el-tooltip>
                        </p>
                        <p class="ellipses">
                          <el-tooltip effect="light" placement="bottom-start" :content="item.sku">
                            <span class="goods-name">
                              SKU编码：{{ item.sku }}
                            </span>
                          </el-tooltip>
                        </p>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="单价（元)" min-width="180">
                <template slot-scope="scope">
                  <span class="top-bg" />
                  <div class="order-details">
                    <div :class="
                      scope.row.goodsList.length > 1
                        ? 'set-height bor-bottom'
                        : 'box'
                    " v-for="(item, index) in scope.row.goodsList" :key="index">
                      {{ item.price | formatMoney }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="数量" min-width="180">
                <template slot-scope="scope">
                  <span class="top-bg" />
                  <div class="order-details">
                    <div :class="
                      scope.row.goodsList.length > 1
                        ? 'set-height bor-bottom bor-right'
                        : 'box'
                    " v-for="(item, index) in scope.row.goodsList" :key="index">
                      {{ item.num }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="订单归属商家" min-width="180">
                <template slot-scope="scope">
                  <span class="top-bg"></span>
                  <div class="order-details">
                    {{ scope.row.applets }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="订单金额" min-width="180">
                <template slot-scope="scope">
                  <span class="top-bg"></span>
                  <div class="order-details">
                    <p class="money">
                      {{ scope.row.orderMoney }}
                    </p>
                    <p>运费：{{ scope.row.shipping }}</p>
                    <p>
                      <i class="iconfont icon-weixin"></i>
                      {{ scope.row.payType }}
                    </p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="订单佣金" min-width="180">
                <template slot-scope="scope">
                  <span class="top-bg"></span>
                  <div class="order-details">
                    <p class="ellipses">
                      一级分销佣金：{{ scope.row.firstCommission }}
                    </p>
                    <p class="ellipses">
                      二级分销佣金：{{ scope.row.secondCommission }}
                    </p>
                    <p class="ellipses">
                      三级分销佣金：{{ scope.row.thirdCommission }}
                    </p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="分销商账号" min-width="180">
                <template slot-scope="scope">
                  <span class="top-bg"></span>
                  <div class="order-details">
                    {{ scope.row.distributorAccount }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="买家账号" min-width="180">
                <template slot-scope="scope">
                  <span class="top-bg">
                    <div class="order-time">
                      下单时间：{{ scope.row.orderTime }}
                    </div>
                  </span>
                  <div class="order-details">
                    {{ scope.row.account }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="订单来源" min-width="180">
                <template slot-scope="scope">
                  <span class="top-bg" />
                  <div class="order-details" v-orderSource="{
                    source: scope.row.orderSource,
                    state: scope.row.orderType
                  }" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="订单状态" min-width="180">
                <template slot-scope="scope">
                  <span class="top-bg">
                    <div class="order-time">
                      支付时间：{{ scope.row.payTime }}
                    </div>
                  </span>
                  <div class="order-details">
                    {{ scope.row.orderState | formatOrderStatus }}
                  </div>
                </template>
              </el-table-column>
              <!--              <el-table-column align="center" label="佣金支付状态" width="120">-->
              <!--                <template slot-scope="scope">-->
              <!--                  <span class="top-bg">-->
              <!--                    <div class="order-time">-->
              <!--                      付款时间：{{ scope.row.payTime }}-->
              <!--                    </div>-->
              <!--                  </span>-->
              <!--                  <div class="order-details">-->
              <!--                    {{ scope.row.paymentStatus }}-->
              <!--                  </div>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
              <el-table-column align="center" label="操作" min-width="180" fixed="right">
                <template slot-scope="scope">
                  <span class="top-bg" />
                  <div class="order-details">
                    <!--                    <el-button-->
                    <!--                      size="98"-->
                    <!--                      class="sub-color"-->
                    <!--                      @click="dialogFormVisible = true"-->
                    <!--                      v-html="'支付佣金'"-->
                    <!--                    />-->
                    <div class="dots-all" v-permission:details="$route.meta.permission">
                      <!--                      <p class="dots" @click="dialogVisible = true">-->
                      <!--                        佣金详情-->
                      <!--                      </p>-->
                      <p class="dots" @click="jumpRoute(scope.row)">
                        订单详情
                      </p>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </TableComponent>
      <div class="mask" v-show="dialogFormVisible">
        <el-dialog :visible.sync="dialogFormVisible" :modal-append-to-body="false" :close-on-press-escape="false"
          :show-close="false" :modal="false" custom-class="dialog" :center="true">
          <el-form :model="form" label-width="auto">
            <el-form-item label="佣金金额：">
              <div class="input-box">
                <div class="input">
                  <el-input v-model="form.money" placehoder="请输入" />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="支付方式：">
              <div class="input-box">
                <div class="input">
                  <el-input v-model="form.paymentType" placehoder="请输入" />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="支付人：">
              <div class="input-box">
                <div class="input">
                  <el-input v-model="form.paymentPerson" placehoder="请输入" />
                </div>
              </div>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button size="98" @click="dialogFormVisible = false" v-html="'取消'" />
            <el-button size="98" class="sub-color" @click="dialogFormVisible = false" v-html="'确定'" />
          </span>
        </el-dialog>
      </div>

      <div class="mask" v-show="dialogVisible">
        <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false" :close-on-press-escape="false"
          :modal="false" custom-class="dialog" :center="true">
          <el-form :model="form1" label-width="auto">
            <el-form-item label="分销商账号：">
              {{ form1.distributorAccount }}
            </el-form-item>
            <el-form-item label="支付方式：">
              {{ form1.paymentType }}
            </el-form-item>
            <el-form-item label="收款账号：">
              {{ form1.account }}
            </el-form-item>
            <el-form-item label="支付方式：">
              {{ form1.paymentType }}
            </el-form-item>
            <el-form-item label="支付人：">
              {{ form1.paymentPerson }}
            </el-form-item>
            <el-form-item label="支付时间：">
              {{ form1.paymentTime }}
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import TableComponent from '../Components/TableComponent'
import SearchComponent from '../Components/SearchComponent'
import updateData from 'mixins/updateData'
// TODO：支付佣金未做
export default {
  name: 'distributorCommission',
  mixins: [updateData],
  components: {
    SearchComponent,
    TableComponent
  },
  data() {
    this.keyMap = {
      order_list: {
        name: 'tableData',
        add_time: 'orderTime',
        app_name: 'applets',
        bill_id: 'billId',
        order_amount: 'orderMoney',
        order_id: 'orderId',
        order_source: 'orderSource',
        order_state: 'orderState',
        order_type: 'orderType',
        pay_sn: 'orderNumber',
        payment_code: 'payType',
        payment_time: 'payTime',
        shipping_fee: 'shipping',
        goods_list: 'goodsList',
        goods_en: 'enName',
        goods_name: 'cnName',
        goods_image: 'imgUrl',
        goods_sku: 'sku',
        goods_price: 'price',
        goods_num: 'num',
        goods_type: 'goodsType',
        member_name: 'account',
        distributor_name: 'distributorAccount',
        primary_distributor: 'firstCommission',
        secondary_distributor: 'secondCommission',
        third_distributor: 'thirdCommission'
      }
    }
    return {
      dialogFormVisible: false,
      dialogVisible: false,
      condition: {
        Merchant: '',
        orderNumber: '',
        sku: '',
        goodsName: '',
        account: '',
        orderSource: '',
        paymentType: '',
        paymentStatus: '',
        time: ''
      },
      tableData: [],
      pagination: {},
      form: {
        money: '',
        paymentType: '',
        paymentPerson: ''
      },
      form1: {
        distributorAccount: '',
        commissionAmount: '',
        account: '',
        paymentType: '',
        paymentPerson: '',
        paymentTime: ''
      }
    }
  },
  created() {
    this._getFinanceOrderList({
      curpage: 1,
      search_model: 'distributor'
    })
  },
  methods: {
    /**
     * 获取对应列表
     */
    _getFinanceOrderList(params) {
      this.api.getFinanceOrderList(params).then(res => {
        this.utils.setCommonCode(res, this)
      })
    }
  }
}
</script>
